import { Link as LinkRouter } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import React from 'react'

/** Material-UI **/
import { Box, Link, makeStyles, Typography } from '@material-ui/core'

import { appName, Configs } from '../../lib/Constants'
import cornerLogo from '../../assets/images/corner_logo.svg'

const pjson = require('../../../package.json')

const useStyles = makeStyles(theme => ({
  container: {
    position: 'relative',
    width: '100%',
    height: '100vh',
    paddingBottom: '80px'
  },
  backgroundImage: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: 'auto',
    maxWidth: '30vw',
    zIndex: 0
  },
  footer: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '80px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 20px',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      height: '60px'
    }
  },
  leftBlock: {
    flex: 1,
    textAlign: 'left'
  },
  centerBlock: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center'
  },
  rightBlock: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '20px'
  },
  links: {
    paddingTop: '4px',
    fontWeight: '400',
    fontSize: '14px',
    color: theme.palette.text.primary,
    textDecoration: 'none',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px'
    }
  },
  footerSmallText: {
    fontSize: '12px',
    fontWeight: '400'
  },
  footerText: {
    fontWeight: '300',
    color: theme.palette.text.primary,
    fontSize: '20px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px'
    }
  }
}))

const Footer = () => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <div className={classes.container}>
      {/* Background image fixed at bottom-left */}
      <img
        alt={'CornerIconLogo'}
        className={classes.backgroundImage}
        src={cornerLogo}
      />

      {/* Footer content */}
      <Box className={classes.footer}>
        {/* Left Block (empty for now) */}
        <Box className={classes.leftBlock} />

        {/* Center Block (App name and year) */}
        <Box className={classes.centerBlock}>
          <Typography component={'span'} className={classes.footerSmallText}>
            @{new Date().getFullYear()} {appName}{' '}
            {t('sign_in.messages.all_rights')}{' '}
            <Link target="_blank" href={Configs.privacyPolicyURL}>
              {t('sign_in.messages.privacy_policy_link')}
            </Link>
          </Typography>
        </Box>

        {/* Right Block (Version and contact link) */}
        <Box className={classes.rightBlock}>
          <LinkRouter
            className={classes.links}
            rel="noopener noreferrer"
            to={{ pathname: Configs.contactUsURL }}
            target="_blank"
          >
            {t('sign_in.contact_us')}
          </LinkRouter>
          <Typography component={'span'} className={classes.footerText}>
            v{pjson.version}
          </Typography>
        </Box>
      </Box>
    </div>
  )
}

export default Footer
